import { useLocation } from "react-router-dom";
import { Resource, ResourceType } from "routers/constant";

export const getResouceTypePath = (path: string) => {
  const resourceType = Object.values(ResourceType).find((x) =>
    path.includes(x)
  );
  return resourceType as ResourceType;
};

export const getResouceFromPath = (path: string) => {
  const resourceType = getResouceTypePath(path);
  const index = path.indexOf(resourceType);

  if (!resourceType) {
    return path.slice(1, path.length) as Resource;
  }

  const resourceName = path.slice(1, index - 1);
  return resourceName as Resource;
};

export const useCurrentResource = (): Resource => {
  const location = useLocation();
  return getResouceFromPath(location.pathname);
};

export const useCurrentResourceType = (): ResourceType => {
  const location = useLocation();
  return getResouceTypePath(location.pathname);
};
